// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const stantler: PokeData = {
  "id": 234,
  "name": "stantler",
  "height": 14,
  "weight": 712,
  "base_experience": 163,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "stomp",
    "jump-kick",
    "sand-attack",
    "tackle",
    "take-down",
    "double-edge",
    "leer",
    "confusion",
    "hypnosis",
    "confuse-ray",
    "role-play",
    "imprison",
    "astonish",
    "extrasensory",
    "calm-mind",
    "me-first",
    "zen-headbutt",
    "captivate",
    "entrainment",
    "lunge",
    "psyshield-bash"
  ],
  "moves": [
    "jump-kick",
    "tackle",
    "leer",
    "confuse-ray",
    "calm-mind",
    "zen-headbutt",
    "lunge",
    "quick-attack",
    "splash",
    "protect",
    "tri-attack",
    "purification",
    "growl"
  ],
  "evolution_chain": {
    "id": 120,
    "item": null,
    "species": [
      {
        "name": "stantler",
        "order": 265,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wyrdeer",
        "order": 899,
        "types": [
          PokeType.NORMAL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 234,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "psyshield-bash"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.AGILE_STYLE_MOVE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 68.25,
    "speed": 85,
    "ability_power": 95
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
